import Script from 'next/script'
import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import type {Block} from '@/services/kontent-ai/types'
import {logMessage} from '@/services/logger/client'

const revTrax = 'https://irxcm.com/RevTrax/js/rtxiframe.jsp'

export type CouponIframeContentItem = IContentItem<{
	desktopProgramId: Elements.TextElement
	petcoMobileProgramId: Elements.TextElement
	petsmartMobileCouponProgramId: Elements.TextElement
}>

export const CouponIframeComponent: Block<CouponIframeContentItem> = ({
	block: {
		elements: {
			desktopProgramId,
			petcoMobileProgramId,
			petsmartMobileCouponProgramId,
		},
	},
	globalConfig: {
		elements: {merchantId, affiliateId, channel, rxChannel},
	},
}) => {
	const makeFrame1Src = `${revTrax}?frameId=1&parent=coupon_iframe_desktop&merchantId=${merchantId}&programId=${desktopProgramId}&affiliateId=${affiliateId}&rx_channel=${rxChannel}&channel=${channel}`

	const makeFrame2Src = `${revTrax}?frameId=2&parent=coupon_petco_mobile&merchantId=${merchantId}&programId=${petcoMobileProgramId}&affiliateId=${affiliateId}&rx_channel=${rxChannel}&channel=${channel}`

	const makeFrame3Src = `${revTrax}?frameId=3&parent=coupon_petco_mobile&merchantId=${merchantId}&programId=${petsmartMobileCouponProgramId}&affiliateId=${affiliateId}&rx_channel=${rxChannel}&channel=${channel}`

	if (desktopProgramId)
		logMessage(
			`From Revtrax - Creating iframe for desktop coupon with Desktop Program ID: ${desktopProgramId}`
		)
	else if (petcoMobileProgramId)
		logMessage(
			`From Revtrax - Creating iframe for Petco mobile coupon with pet Co Mobile Program ID: ${petcoMobileProgramId}`
		)
	else if (petsmartMobileCouponProgramId)
		logMessage(
			`From Revtrax - Creating iframe for PetSmart mobile coupon with pet smart Mobile Program ID: ${petsmartMobileCouponProgramId}`
		)
	else {
		logMessage(
			'From Revtrax - Unable to create iframe since program id is not available'
		)
	}

	return (
		<>
			{desktopProgramId ? (
				<Script
					async
					id="make-frame-1"
					onLoad={() => {
						if (window.makeFrame1) {
							window.makeFrame1()
						}
					}}
					src={makeFrame1Src}
				/>
			) : null}
			{petcoMobileProgramId ? (
				<Script
					async
					id="make-frame-2"
					onLoad={() => {
						if (window.makeFrame2) {
							window.makeFrame2()
						}
					}}
					src={makeFrame2Src}
				/>
			) : null}
			{petsmartMobileCouponProgramId ? (
				<Script
					async
					id="make-frame-3"
					onLoad={() => {
						if (window.makeFrame3) {
							window.makeFrame3()
						}
					}}
					src={makeFrame3Src}
				/>
			) : null}
			<div className="w-full" id="coupon_iframe_desktop" />
			<div className="w-full" id="coupon_petco_mobile" />
			<div className="w-full" id="coupon_pet_smart_mobile" />
		</>
	)
}
